// Module
var code = "<script>let $PanelEditRowTableUsers</script> <div ng-include=\"$PanelEditRowTableUsers.getTemplate()\"></div> ";
// Exports
module.exports = code;